import { Paginator } from "primereact/paginator";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import usePaginationStats from "src/hooks/usePaginationStats";
import {
  GRID_PAGE_SIZES,
  NUMBER_OF_ROWS_PER_PAGE,
} from "src/resources/constant";

interface GridPaginatorProps {
  totalRowsCount: number;
  currentPage: number;
  numberOfRowsPerPage: number;
  setNumberOfRowsPerPage: (rows: number) => void;
  setGridCurrentPage: (page: number) => void;
  tableRef: any;
}

const GridPaginator: React.FC<GridPaginatorProps> = ({
  totalRowsCount,
  currentPage,
  numberOfRowsPerPage,
  setNumberOfRowsPerPage,
  setGridCurrentPage,
  tableRef,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);
  const [firstRowIndex, setFirstRowIndex] = useState<number>(0);
  const numberOfPages = useMemo(
    () => Math.ceil(totalRowsCount / numberOfRowsPerPage),
    [totalRowsCount, numberOfRowsPerPage]
  );
  const onPageChange = (e: { rows: number; first: any; page: any }) => {
    const numberOfRows = e.rows ?? NUMBER_OF_ROWS_PER_PAGE;
    dispatch(setNumberOfRowsPerPage(numberOfRows) as any);
    setFirstRowIndex(e.first ?? 0);
    dispatch(setGridCurrentPage(e.page ?? 0) as any);
  };
  usePaginationStats(
    tableRef,
    totalRowsCount,
    firstRowIndex,
    numberOfRowsPerPage,
    currentPage
  );
if (totalRowsCount === 0) {
  return null;
}

return (
  <Paginator
    totalRecords={totalRowsCount}
    first={currentPage * numberOfRowsPerPage}
    rows={numberOfRowsPerPage}
    rowsPerPageOptions={GRID_PAGE_SIZES}
    onPageChange={onPageChange}
    className="grid-paginator-bottom"
    template="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    currentPageReportTemplate={`${t("page")} ${currentPage + 1} ${t("of")} ${
      numberOfPages || 1
    }`}
  />
);
};

export default GridPaginator;
